import { Button } from "@/components/ui/button";
import moment from "moment";
import { useApiList } from "@/queries";

export function PartUsageDetailHandler({ currentExport, data, dataSave, exportToExcel }) {
  const { data: users } = useApiList(
    currentExport == "part usage" ? "/v2/user" : null,
    [currentExport],
  );
  const userByAlias = new Map();
  users?.forEach((u) => {
    if (u.alias) userByAlias.set(String(u.alias), u);
    if (u.code) userByAlias.set(String(u.code), u);
  });
  const resolveRceCode = (val) => {
    if (!val) return "-";
    const hit = userByAlias.get(String(val));
    if (hit) {
      return (
        hit.repair_center?.code ||
        hit.repair_center?.alias ||
        hit.repair_center_engineer?.code ||
        hit.repair_center_engineer?.alias ||
        hit.alias ||
        String(val)
      );
    }
    return String(val);
  };

  if (currentExport == "part usage") {
    const exportData =
      data.part_usage_ticket_type == "PRT"
        ? dataSave.part_usages
            .filter((obj) => {
              if (data.date_from && data.date_to) {
                return moment(obj.created_at).isBetween(
                  data.date_from,
                  data.date_to,
                );
              } else {
                return true;
              }
            })
            .filter((obj) => {
              if (data.part_type) {
                return obj.type == data.part_type;
              } else {
                return true;
              }
            })
            .map((obj) => {
              return {
                "Part Number": obj.part_detail.part_number,
                "Part Name": obj.part_detail.name,
                "Part SN": obj.part_sn_in,
                Qty: obj.part_quantity ? obj.part_quantity : 1,
                "Last Usage Time": obj.created_at
                  ? moment(obj.created_at)
                      .subtract(7, "hours")
                      .format("YYYY-MM-DD HH:mm:ss")
                  : "-",
                "PRT No": obj.part_request_ticket.pr_ticket_no,
                "SE Code":
                  obj.service_order_ticket.on_duty_service_engineer.code,
              };
            })
            .filter((obj) => obj != undefined)
        : dataSave.repair_part_usages
            .filter((obj) => {
              if (data.date_from && data.date_to) {
                return moment(obj.created_at).isBetween(
                  data.date_from,
                  data.date_to,
                );
              }
              return true;
            })
            .map((obj) => {
              const rrt = obj.repair_request_ticket;
              const rrtDetails = rrt?.rrt_details;
              const repairedPartSn =
                rrtDetails?.part_sn ||
                rrt?.part_repairs?.part_repairables?.part_sn ||
                "-";
              const rceCode = resolveRceCode(obj.updated_by);
              return {
                "Part Number": obj.part_detail?.part_number || "-",
                "Part Name": obj.part_detail?.name || "-",
                "Part SN": repairedPartSn,
                Qty: obj.part_quantity,
                "Last Usage Time": obj.created_at
                  ? moment(obj.created_at)
                      .subtract(7, "hours")
                      .format("YYYY-MM-DD HH:mm:ss")
                  : "-",
                "RRT No": rrt?.rr_ticket_no || "-",
                "RCE Code": rceCode,
              };
            })
            .filter((obj) => obj != undefined);

    return (
      <Button
        variant="primary"
        onClick={() =>
          exportToExcel(
            exportData,
            `part_usage_detail_${moment().format("hhmm_DDMMYYYY")}.xlsx`,
          )
        }
      >
        Submit
      </Button>
    );
  }
  return null;
}
